<template>
  <div>
    <router-link :to="{name:l.name}" v-for="l in links" :key="l.name">
      <mdb-btn class="brown lighten-1 sub-page-nav">{{l.text}}</mdb-btn>
    </router-link>
    <router-link v-if="add" :to="{name:add.name}">
      <a class="btn-floating btn-lg brown lighten-1 sub-page-nav"><i class="fas fa-plus"></i></a>
    </router-link>
  </div>
</template>

<script>
export default {
    name:"SubPageNav",
    props:["links","add"]
};
</script>

<style>
.router-link-active .sub-page-nav{
  background-color:#fb8c00 !important;
}
</style>